<template>
    <div :class="['reward-task', language]">
        <Navbar :statusHeight="0" :language="language" :title="$t('赏金任务')" :isNavtiveBack="true"></Navbar>
        <div class="reward-container">
            <div class="reward-container-box">
                <div class="reward-top"
                    :style="{ backgroundImage: `url(${require(`../../assets/reward/reward-top-bg-${language}.png`)})` }">
                </div>
                <div class='reward-content' ref="rewardList">
                    <div class="reward-content-contorll">
                        <RewardItem :title="$t('进入奖池的用户')">
                            <template #content>
                                <div style="padding: 16px 15px;">
                                    <div class="reward-user-list">
                                        <div class="reward-user-item" v-for="(item, index) in userList" :key="index">
                                            <div v-if="item.headUrl" class="reward-user-item-img"
                                                :data-giftCount="item.giftCount">
                                                <img :src="item.headUrl" alt="">
                                                <div class="user-part" v-if="item.headPendantUrl">
                                                    <Pendant :url="item.headPendantUrl" />
                                                </div>
                                            </div>
                                            <div class="reward-user-item-img-emtpy" v-else>{{ index + 1 }}</div>
                                            <div class="reward-user-item-name text-ellipsis">
                                                {{ item.name ? item.name : $t('立即参加') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="count-person">{{ $t(`共x人`, { count: joinRewardCount }) }}</div>
                                </div>
                            </template>
                        </RewardItem>
                        <RewardItem :title="$t('活动时间')">
                            <template #content>
                                <div style="padding: 16px 15px;">
                                    <div :class="['activity-time', language === 'ug' && 'ug-normal-text']">
                                        {{ $t('x月x日~x月x日「每日开奖」', {m1: 8, m2: 12, d1: 11, d2: 31}) }}
                                    </div>
                                </div>
                            </template>
                        </RewardItem>
                        <RewardItem :title="$t('活动奖励')">
                            <template #content>
                                <div :class="['activity-task-content', language === 'ug' && 'ug-normal-text']">
                                    <div class="activity-task-title"
                                        :style="{ backgroundImage: `url(${require(`../../assets/reward/complete-task-${language}.png`)})` }">
                                    </div>
                                    <div :class="['activity-task-list', language === 'ug' && 'activity-task-list-ug']">
                                        <div class="activity-task-item">
                                            <div class="activity-task-item-title">{{ $t('奖池') }}</div>
                                            <div class="activity-task-item-content">
                                                <p>{{ $t('每日开奖，每日瓜分') }}<span>1300</span>{{ $t('积分') }}</p>
                                                <span>{{ $t('05:00~次日05:00 算一天') }}</span>
                                            </div>
                                        </div>
                                        <div class="activity-task-item">
                                            <div class="activity-task-item-title">{{ $t('开奖条件') }}</div>
                                            <div class="activity-task-item-content">
                                                <p>{{ $t('完成任务的人数达到') }}<span>4</span>{{ $t('人即可开奖') }}</p>
                                            </div>
                                        </div>
                                        <div class="activity-task-item">
                                            <div class="activity-task-item-title">{{ $t('活动任务') }}</div>
                                            <div class="activity-task-item-content">
                                                <p>{{ $t('完成语音直播房') }}<span>2</span>{{ $t('个“礼物任务”,即可参与瓜分积分') }}</p>
                                            </div>
                                        </div>
                                        <div class="activity-task-item">
                                            <div class="activity-task-item-title">{{ $t('活动规则') }}</div>
                                            <div class="activity-task-item-content">
                                                <p>{{ $t('获得“礼物任务”的礼物越多,排名越靠前,瓜分获得的积分越多') }}</p>
                                            </div>
                                        </div>
                                        <div class="activity-task-item">
                                            <div class="activity-task-item-title">{{ $t('完成奖励') }}</div>
                                            <div class="activity-task-item-content">
                                                <p class="complete">{{ $t('第1名:') }}<span>650</span><img src="@/assets/icon-bean.png"
                                                        alt=""></p>
                                                <p class="complete">{{ $t("第2名:") }}<span>260</span><img src="@/assets/icon-bean.png"
                                                        alt=""></p>
                                                <p class="complete">{{ $t('第3名:') }}<span>130</span><img src="@/assets/icon-bean.png"
                                                        alt=""></p>
                                                <p class="complete">{{ $t('第4~10名:30') }}<img src="@/assets/icon-bean.png" alt=""></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </RewardItem>
                        <RewardItem :title="$t('x月x日获奖用户', { month, day })" v-if="rewardList.length">
                            <template #content>
                                <div class="waring-reward-box">
                                    <div class="waring-reward-list">
                                        <div class="waring-reward-item" v-for="(value, index) in rewardList"
                                            :key="index">
                                            <div class="waring-reward-item-img">
                                                <img :src="value.headUrl" alt="">
                                                <div class="user-part" v-if="value.headPendantUrl">
                                                    <Pendant :url="value.headPendantUrl" />
                                                </div>
                                            </div>
                                            <div
                                                :class="['waring-reward-item-info', language === 'ug' && 'ug-normal-text']">
                                                <p class="user-name text-ellipsis">{{ value.name || '-' }}</p>
                                                <span>{{ $t('在赏金活动中获得') }}</span><span class="bean">{{
                                                    value.goldBeanCount
                                                    }}</span><span>{{ $t('积分') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="empty" v-else>
                                        <img src="@/assets/Empty_NoData.png" alt="">
                                        <p>{{ $t('暂无获奖名单～') }}</p>
                                    </div> -->
                                </div>
                            </template>
                        </RewardItem>
                        <RewardItem :title="$t('活动说明')">
                            <template #content>
                                <div style="padding: 16px 15px;">
                                    <div :class="['activity-desc', language == 'ug' && 'ug-normal-text']">
                                        <p>
                                            {{ $t('1. 礼物任务，展示“5/5”算完成1个任务(如下图所示)，完成任意2个礼物任务即可参与瓜分积分.') }}
                                            <img :src="require(`@/assets/reward/reward-give-icon-${language}.png`)"
                                                alt="">
                                        </p>
                                        <p>{{ $t('2. 语音直播间房主和成员均可参加.') }}</p>
                                        <p>{{ $t('3. 奖池排行实时更新.') }}</p>
                                        <p>{{ $t('4. 开奖后，瓜分的积分次日到账.') }}</p>
                                        <p>{{ $t('5. 活动最终解释权归平台所有.') }}</p>
                                    </div>
                                </div>
                            </template>
                        </RewardItem>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RewardItem from './components/RewardItem.vue';
import Navbar from '@/components/Navbar.vue';
import { CommonModule } from '@/store/modules/common'
import Pendant from '@/components/Pendant.vue'
import { getYesterdayBountyUser, getTodayBountyUser } from '@/api'

export default {
    components: {
        Navbar,
        RewardItem,
        Pendant
    },
    data() {
        return {
            joinRewardCount: 2,
            userList: [],
            rewardList: [],
            language: 'ug',
            month: new Date().getMonth() + 1,
            day: new Date().getDate() - 1,
            isShwoYesterday: false
        }
    },
    methods: {
        setLanguage() {
            // 获取当前语言
            console.log('setLanguage', window.location.href)
            const data = this.$route.query.language || 'ug'
            this.language = data
            this.$i18n.locale = data
            CommonModule.setLanguage(data)
        },
        addUserListEmpty() {

            if (this.userList.length < 5) {
                this.userList = this.userList.concat(new Array(5 - this.userList.length).fill({}));
            } else {
                this.userList = this.userList.concat(new Array(2).fill({}));
            }
        },
        async getList() {
            getTodayBountyUser().then(res => {
                if (res.code == 1001 && res.data) {
                    this.userList = res.data.bountyUserVOs
                    this.joinRewardCount = res.data.totalUser
                    this.addUserListEmpty()
                }
            })

            await getYesterdayBountyUser().then(res => {
                if (res.code == 1001 && res.data) {
                    this.rewardList = res.data
                }
            })

            this.$nextTick(() => {
                const rewardListEle = this.$refs['rewardList']
                console.log(rewardListEle.clientHeight);
                rewardListEle.style.height = rewardListEle.clientHeight - 15 + 'px'
                console.log(rewardListEle.clientHeight);
            })
        }
    },
    async created() {
        this.setLanguage()
        this.getList()
    }
}
</script>

<style lang="scss" scoped>
.reward-task {
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
}

.reward-container {
    flex: 1;
    overflow-y: scroll;
    position: relative;

    .reward-top {
        width: 100%;
        height: 342px;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .reward-content {
        display: flex;
        width: 100%;
        flex-direction: column;
        align-items: center;
        padding: 0 20px 32px;
        background: linear-gradient( 180deg, #8C9CFF 0%, #4EA1D5 100%);
        box-shadow: inset 0px 12px 16px 0px rgba(255,255,255,0.25);
        border-radius: 50px 50px 0 0;
        position: absolute;
        top: 300px;
        left: 50%;
        transform: translateX(-50%);
        box-sizing: border-box;
        
        .reward-content-contorll {
            width: 100%;
            transform: translateY(-55px);

            .reward-user-list {
                display: flex;
                overflow-x: scroll;
                padding-top: 5px;
                
                &::-webkit-scrollbar {
                    display: none;
                }

                .reward-user-item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-between;
                    width: 56px;
                    height: 70px;
                    text-align: center;
                    margin-right: 4px;

                    .reward-user-item-img {
                        position: relative;

                        &::after {
                            content: attr(data-giftCount);
                            position: absolute;
                            right: 1px;
                            bottom: 1px;
                            width: 15px;
                            height: 15px;
                            line-height: 15px;
                            border-radius: 50%;
                            background-color: #fff;
                            border: 1px solid #FCD23F;
                            font-size: 10px;
                            color: #181818;
                            text-align: center;
                        }

                        img {
                            width: 42px;
                            height: 42px;
                            border-radius: 50%;
                        }

                        .user-part {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            width: 56px;
                            height: 56px;
                        }
                    }

                    .reward-user-item-img-emtpy {
                        width: 42px;
                        height: 42px;
                        line-height: 42px;
                        border-radius: 50%;
                        border: 1px double #F1C0FF;
                        font-weight: 500;
                        font-size: 18px;
                        color: #181818;
                        text-align: center;
                        background-color: #fff;
                    }

                    .reward-user-item-name {
                        width: 56px;
                        font-weight: 400;
                        font-size: 12px;
                        color: #181818;
                        padding-bottom: 1px;
                    }
                }

                .reward-user-item:last-child {
                    margin-right: 0;
                }
            }

            .activity-time {
                font-size: 16px;
                color: #181818;
                text-align: center;
            }

            .count-person {
                font-weight: 500;
                font-size: 16px;
                color: #181818;
                text-align: center;
                padding-top: 8px;
            }

            .activity-task-content {
                display: flex;
                flex-direction: column;
                padding: 16px 15px;

                .activity-task-title {
                    align-self: center;
                    width: 221px;
                    height: 31px;
                    background-repeat: no-repeat;
                    background-size: contain;
                }

                .activity-task-list {
                    padding-top: 10px;

                    .activity-task-item {
                        display: flex;
                        background-color: #fff;
                        border-radius: 8px;
                        margin-bottom: 8px;

                        .activity-task-item-title {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            width: 80px;
                            min-height: 70px;
                            font-size: 14px;
                            color: #FFFFFF;
                            border-radius: 8px 0px 0px 8px;
                            text-align: center;
                            background: #3BB1F6;
                            padding: 0 8px;
                            box-sizing: border-box;
                        }

                        .activity-task-item-content {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            flex: 1;
                            padding: 7px 8px;
                            .complete {
                                display: flex;
                                align-items: center;
                            }

                            p {
                                font-size: 14px;
                                color: #023122;
                                line-height: 22px;

                                span {
                                    font-weight: bold;
                                    font-size: 14px;
                                    color: #FA5051;
                                }

                                img {
                                    width: 14px;
                                    height: 15px;
                                    margin-left: 2px;
                                    vertical-align: middle;
                                }
                            }

                            span {
                                font-size: 10px;
                                color: #FA5051;
                            }
                        }
                    }
                }

                .activity-task-list-ug {
                    .activity-task-item-content {
                        p {
                            line-height: 20px !important;
                        }
                    }
                }
            }

            .waring-reward-box {
                display: flex;
                align-items: center;
                padding: 20px 20px;
                height: 215px;
            }

            .waring-reward-list {
                height: 100%;
                overflow-y: scroll;
                overflow-x: hidden;
                padding: 5px 0 0 5px;
                
                &::-webkit-scrollbar {
                    display: none;
                }

                .waring-reward-item {
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;

                    .waring-reward-item-img {
                        position: relative;

                        img {
                            width: 36px;
                            height: 36px;
                            border-radius: 50%;
                        }

                        .user-part {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            width: 48px;
                            height: 48px;
                        }
                    }

                    .waring-reward-item-info {
                        padding-left: 10px;

                        .user-name {
                            width: 215px;
                        }

                        p {
                            font-weight: 500;
                            font-size: 14px;
                            color: #181818;
                            padding-bottom: 3px;
                        }

                        span {
                            font-weight: 400;
                            font-size: 12px;
                            color: #333333;
                        }

                        .bean {
                            color: #FA5051;
                            padding: 0 3px;
                        }
                    }
                }

                .waring-reward-item:last-child {
                    margin-bottom: 0;
                }
            }

            .activity-desc {
                p {
                    line-height: 23px;
                    font-size: 16px;
                    color: #181818;
                }

                p:not(:last-child) {
                    margin-bottom: 10px;
                }

                img {
                    display: block;
                    width: 108px;
                    height: 42px;
                }
            }
        }
    }

    .empty {
        width: 120px;
        height: 108px;
        text-align: center;
        font-size: 14px;
        color: #999999;

        p {
            padding-top: 8px;
        }
    }

    .ug-normal-text {
        font-family: system-ui;
    }
}
</style>